export const USER_SESSION_EXPIRED_MESSAGE = 'Your session has expired. Please log in again.';
export const ADMIN_SESSION_EXPIRED_MESSAGE = 'Admin session expired. Please reconnect your wallet.';

export const USER_SESSION_EXPIRED_EVENT = 'prismax:user-session-expired';
export const ADMIN_SESSION_EXPIRED_EVENT = 'prismax:admin-session-expired';
export const ADMIN_SESSION_REFRESHED_EVENT = 'prismax:admin-session-refreshed';

export function getApiErrorMessage(data, fallback = 'Request failed') {
    return data?.msg || data?.message || data?.error || data?.detail || fallback;
}

export function isSessionExpiredError(errorOrMessage) {
    const message = typeof errorOrMessage === 'string'
        ? errorOrMessage
        : errorOrMessage?.message;
    const text = String(message || '').toLowerCase();

    return text.includes('invalid token')
        || text.includes('token expired')
        || text.includes('expired token')
        || text.includes('jwt expired')
        || text.includes('invalid jwt')
        || text === 'unauthorized'
        || text.includes('unauthorized access')
        || text.includes('not authenticated');
}
